import React, { FC } from 'react';

import { useTrustpilot } from '../trustpilotCommon/useTrustpilot';

import { TrustpilotCarouselBespoke } from './TrustpilotCarouselBespoke';
import { TrustpilotRatingBespoke } from './TrustpilotRatingBespoke';

import styles from './TrustpilotBespoke.scss';

type TrustpilotBespokeProps = {
  brand: {
    display_name: string;
    slug: string;
  };
};

export const TrustpilotBespoke: FC<TrustpilotBespokeProps> = ({ brand }) => {
  const cardTruncationLength = 78;
  const cardTitleTruncationLength = 27;

  const {
    loaded, title, tpData, tpReviews: reviews,
  } = useTrustpilot({ brand, maxLength: cardTruncationLength });

  return (
    <section className={styles.component}>
      <div className={styles.container}>
        <h2>{title}</h2>
        <TrustpilotCarouselBespoke
          {...{
            brand,
            cardTitleTruncationLength,
            cardTruncationLength,
            loaded,
            reviews,
          }}
        />
        {tpData && tpData?.rating !== '0' && <TrustpilotRatingBespoke {...{ tpData }} />}
      </div>
    </section>
  );
};
